import React, { useState, useContext, useEffect, useRef } from 'react'
import { Button, Tabs, Tab, Box, Drawer, TextField } from '@material-ui/core'

import GridViewAuction from '@/custom/components/molecules/ProductCard/GridViewAuction'
import ListView from '@/custom/components/molecules/ProductCard/AuctionCard'
import ProductView from '@/custom/components/organisms/ProductView'
import NoRecordsFound from '@/custom/components/atoms/NoRecordsFound'
import CommonContext from '@/product/context/common/commonContext'
import { useHistory, useLocation } from 'react-router-dom'
import { useFormik, validateYupSchema } from 'formik'
import Slider from 'react-slick'
import { Link } from 'react-router-dom'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { Pagination } from '@material-ui/lab'
import AuctionContext from '@/product/context/auction/auctionContext'
import Loaders from '@/product/components/molecules/Loaders'
import { is } from 'date-fns/locale'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const CustomNextArrow = (props) => {
    const { className, style, onClick } = props
    return (
        <div
            className={className}
            style={{
                ...style,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                background: 'white',
                borderRadius: '50%',
                boxShadow: '0px 0px 6px #d2dce6',
                right: '-10px',
                zIndex: 1,
                width: '40px',
                height: '40px',
                cursor: 'pointer',
            }}
            onClick={onClick}
        >
            <span
                className="material-icons"
                style={{ color: 'black', position: 'relative', left: '-10px' }}
            >
                east
            </span>
        </div>
    )
}

const CustomPrevArrow = (props) => {
    const { className, style, onClick } = props
    return (
        <div
            className={className}
            style={{
                ...style,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                background: 'white',
                boxShadow: '0px 0px 6px #d2dce6',
                borderRadius: '50%',
                left: '-10px',
                zIndex: 1,
                width: '40px',
                height: '40px',
                cursor: 'pointer',
            }}
            onClick={onClick}
        >
            <span
                className="material-icons"
                style={{ color: 'black', rotate: '180deg', position: 'relative', left: '-10px' }}
            >
                east
            </span>
        </div>
    )
}

function TabPanel(props) {
    const { children, value, index, ...other } = props
    return (
        <div
            className="pv-tab-panel"
            hidden={value !== index}
            aria-labelledby={`pv-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </div>
    )
}

const TabPanelComp = (props) => {
    const [value, setValue] = useState(0)
    const [drawerState, setDrawerState] = useState({
        open: false,
        product: null,
    })
    const [isLoading, setIsLoading] = useState(true)
    const [filteredAuction, setFilteredAuction] = useState([])
    const [searchTERM, setsearchTERM] = useState('')
    const searchRef = useRef('')
    const auctionContext = useContext(AuctionContext)
    const commonContext = useContext(CommonContext)
    const history = useHistory()
    const location = useLocation()
    const { search_allauctions, getAllAuctionProducts } = auctionContext
    const { searchValue, setSearchValue } = commonContext
    const [loaderCount, setLoaderCount] = useState(6)

    useEffect(() => {
        function updateLoaderCount() {
            if (window.innerWidth < 480) setLoaderCount(1)
            else if (window.innerWidth < 768) setLoaderCount(1)
            else if (window.innerWidth < 1180) setLoaderCount(2)
            else setLoaderCount(3)
        }
        updateLoaderCount()
        window.addEventListener('resize', updateLoaderCount)
        return () => window.removeEventListener('resize', updateLoaderCount)
    }, [])
    const searchAuctionFormik = useFormik({
        initialValues: {
            limit: 10,
            page: 1,
            orderby: 'ac.id, desc',
            market_status: 'open',

            having: {
                future_active: {
                    value: '0',
                    type: 'in',
                    field: 'future_active',
                },
            },
            filters: {
                search: {
                    value: '',
                    type: 'like',
                    field: 'ac.title,ac.id',
                },
            },
        },
    })
    // Sample product data - replace with your actual data source

    const handleTabChange = (event, newValue) => {
        console.log(newValue, 'kkkkkkk')
        setValue(newValue)
    }

    const toggleDrawer =
        (open, product = null) =>
        () => {
            setDrawerState({ open, product })
        }

    const handlePageChange = (event, newPage) => {
        // Handle pagination for current tab
        const tabType = value === 0 ? 'ongoing' : 'upcoming'
        // Fetch new page data here
    }
    useEffect(() => {
        setIsLoading(false)
        if (search_allauctions.from === 'auctionval') {
            setFilteredAuction(search_allauctions.records.length ? search_allauctions.records : [])
            //  setTimeout(() => {
            //      setIsLoading(false)
            //  }, 1000)
        }
    }, [search_allauctions])
    const settings = {
        dots: false,
        infinite: filteredAuction.length > 2 ? true : false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: true,
        nextArrow: <CustomNextArrow />,
        prevArrow: <CustomPrevArrow />,
        responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 3 } },
            { breakpoint: 768, settings: { slidesToShow: 2 } },
            { breakpoint: 480, settings: { slidesToShow: 1 } },
        ],
    }
    const onHandlePageAuction = (event, value) => {
        searchAuctionFormik.setFieldValue(`page`, value)
    }
    useEffect(() => {
        // Always clear existing timeout
        if (searchRef.current) {
            clearTimeout(searchRef.current)
        }
        setIsLoading(true)
        if (searchTERM) {
            searchRef.current = setTimeout(() => {
                getAllAuctionProducts(
                    {
                        ...searchAuctionFormik.values,
                        market_status: value == 2 ? 'closed' : 'open',

                        having: {
                            future_active: {
                                value: value == 1 ? 1 : '0',
                                type: 'in',
                                field: 'future_active',
                            },
                        },
                        filters: {
                            search: {
                                value: searchTERM,
                                type: 'like',
                                field: 'ac.title,ac.id',
                            },
                            // searchStatus: {
                            //     value: value == 2 ? 'closed' : '',
                            //     type: 'in',
                            //     field: 'ac.market_status',
                            // },
                        },
                    },
                    'auctionval',
                )
            }, 3000)
        } else {
            searchAuctionFormik.setFieldValue('having.future_active.value', value == 1 ? 1 : '0')
            getAllAuctionProducts(
                {
                    ...searchAuctionFormik.values,
                    market_status: value == 2 ? 'closed' : 'open',
                    having: {
                        future_active: {
                            value: value == 1 ? 1 : '0',
                            type: 'in',
                            field: 'future_active',
                        },
                    },
                    filters: {
                        search: {
                            value: searchTERM,
                            type: 'like',
                            field: 'ac.title,ac.id',
                        },
                        // searchStatus: {
                        //     value: value == 2 ? 'closed' : '',
                        //     type: 'in',
                        //     field: 'ac.market_status',
                        // },
                    },
                },
                'auctionval',
            )
        }
        // Schedule a search (even if searchTERM is empty)

        // Clean up on unmount or when searchTERM changes
        return () => {
            if (searchRef.current) {
                clearTimeout(searchRef.current)
            }
        }
    }, [searchTERM, value, searchAuctionFormik.values.page])

    return (
        <div className="homeBtnCnt mt-2">
            <div className="homeBtnCntFlex d-flex align-items-center justify-content-between mb-4">
                <Tabs
                    value={value}
                    onChange={handleTabChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                >
                    <Tab
                        label={props.auctionView === 'grid' ? 'Ongoing' : 'Ongoing Auction'}
                        id="pv-tab-0"
                    />
                    <Tab
                        label={props.auctionView === 'grid' ? 'Upcoming' : 'Upcoming Auction'}
                        id="pv-tab-1"
                    />
                    <Tab
                        label={props.auctionView === 'grid' ? 'Closed' : 'Closed Auction'}
                        id="pv-tab-2"
                    />
                </Tabs>

                {props.auctionsList && (
                    <div className="searchBar">
                        <div>
                            <TextField
                                variant="outlined"
                                placeholder="Enter three or more characters to perform search"
                                value={searchValue}
                                onChange={(e) => setsearchTERM(e.target.value)}
                                InputProps={{
                                    endAdornment: <span className="material-icons">search</span>,
                                }}
                            />
                        </div>
                    </div>
                )}
            </div>

            {/* <TabPanel value={value} index={0}> */}
            {isLoading ? (
                <div
                    className={
                        props.auctionView === 'grid'
                            ? 'loaderWrapper'
                            : 'listviewLoader loaderWrapper'
                    }
                >
                    <Loaders
                        name={
                            props.auctionView === 'grid' ? 'product_grid_view' : 'product_list_view'
                        }
                        isLoading={isLoading}
                        loop={loaderCount}
                    />
                </div>
            ) : (
                <>
                    {filteredAuction.length > 0 ? (
                        props.auctionView === 'grid' ? (
                            <>
                                {/* <div className="product-grid"> */}
                                <Slider {...settings}>
                                    {filteredAuction.map((product, index) => (
                                        <GridViewAuction
                                            key={`ongoing-${index}`}
                                            data={product}
                                            drawerHandler={toggleDrawer(true, product)}
                                        />
                                    ))}
                                </Slider>
                                {/* </div> */}
                            </>
                        ) : (
                            <>
                                <div className="product-list">
                                    {filteredAuction.map((product, index) => (
                                        <ListView
                                            value={value}
                                            key={`ongoing-${index}`}
                                            data={product}
                                            drawerHandler={toggleDrawer(true, product)}
                                        />
                                    ))}
                                </div>
                                <div className="d-flex justify-content-between align-items-left flex-wrap w-100 my-3 pagination-wrapper">
                                    <h6>
                                        Showing {search_allauctions.setDisp} of{' '}
                                        {search_allauctions.totalRecords}
                                    </h6>
                                    <Pagination
                                        count={Math.ceil(
                                            search_allauctions.totalRecords /
                                                searchAuctionFormik.values.limit,
                                        )}
                                        page={searchAuctionFormik.values.page}
                                        onChange={onHandlePageAuction}
                                        siblingCount={3}
                                        showFirstButton
                                        showLastButton
                                        boundaryCount={2}
                                    />
                                </div>
                            </>
                        )
                    ) : (
                        <NoRecordsFound />
                    )}
                </>
            )}

            {/* </TabPanel> */}

            {/* Upcoming Auctions Tab
            <TabPanel value={value} index={1}>
                {products.upcoming.length > 0 ? (
                    <>
                        <div className="product-grid">
                            {products.upcoming.map((product, index) => (
                                <ListView
                                    key={`upcoming-${index}`}
                                    data={product}
                                    drawerHandler={toggleDrawer(true, product)}
                                />
                            ))}
                        </div>
                        <Pagination
                            count={Math.ceil(products.totalRecords / 12)}
                            page={1}
                            onChange={handlePageChange}
                            className="pagination"
                        />
                    </>
                ) : (
                    <NoRecordsFound />
                )}
            </TabPanel> */}
        </div>
    )
}

export default TabPanelComp
